import React from "react";

// Comic-book styled "meme coin" avatar.
// Uses only SVG + colors from the fighter — no emoji, no stock photos.
export const CoinAvatar = ({ fighter, size = 160, className = "", spinning = false }) => {
  const { initial, color, accent, name } = fighter;
  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width: size, height: size }}
      data-testid={`coin-avatar-${fighter.id}`}
      aria-label={`${name} coin`}
    >
      <svg
        viewBox="0 0 160 160"
        width={size}
        height={size}
        className={spinning ? "anim-spin-slow" : ""}
      >
        {/* Outer black ring */}
        <circle cx="80" cy="80" r="76" fill="#000" />
        {/* Coin face */}
        <circle cx="80" cy="80" r="68" fill={color} />
        {/* Inner ring (darker accent) */}
        <circle
          cx="80"
          cy="80"
          r="60"
          fill="none"
          stroke={accent}
          strokeWidth="4"
          strokeDasharray="6 4"
        />
        {/* Halftone dots overlay */}
        <defs>
          <pattern id={`dots-${fighter.id}`} x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1.1" fill={accent} opacity="0.5" />
          </pattern>
          <clipPath id={`clip-${fighter.id}`}>
            <circle cx="80" cy="80" r="60" />
          </clipPath>
        </defs>
        <rect
          x="20"
          y="20"
          width="120"
          height="60"
          fill={`url(#dots-${fighter.id})`}
          clipPath={`url(#clip-${fighter.id})`}
        />
        {/* Shine highlight */}
        <ellipse cx="55" cy="48" rx="22" ry="10" fill="#fff" opacity="0.55" />
        {/* Initial */}
        <text
          x="80"
          y="102"
          textAnchor="middle"
          fontFamily="Bungee, Impact, sans-serif"
          fontSize="72"
          fill="#000"
          stroke="#000"
          strokeWidth="2"
        >
          {initial}
        </text>
      </svg>
    </div>
  );
};

export default CoinAvatar;
